<template>
    <div class="library-deliverable-table-status-cell">
        <QaStatusLabel display="block" :is-clickable="true" :status="status" @click="$emit('click')" />
    </div>
</template>

<script lang="ts">
import QaStatusLabel from "@/components/Qa/QaStatusLabel.vue";
import type { BannerQaStatus } from "@/enums/banners";
import type { PropType } from "vue";

export default {
    components: {
        QaStatusLabel
    },
    props: {
        status: {
            required: true,
            type: String as PropType<(typeof BannerQaStatus)[keyof typeof BannerQaStatus]>
        }
    },
    emits: ["click"]
};
</script>

<style lang="scss">
@use "@style/variables" as *;
</style>
